const parseEnvBoolean = (key: string) => {
	const value = import.meta.env[key] || 'false';
	let response = false;

	try {
		response = JSON.parse(value);
	} catch {
		response = false;
	}

	return response;
};

const features = {
	POS_REGISTER: parseEnvBoolean('VITE_POS_REGISTER'),
	GRID_COLUMNS_OVERLAY: parseEnvBoolean('VITE_GRID_COLUMNS_OVERLAY'),
	CUSTOMER_DATA_EMAIL_CHANGE: parseEnvBoolean('VITE_CUSTOMER_DATA_EMAIL_CHANGE'),
	MANDATORY_CUSTOMER_PHONE_REGISTER: parseEnvBoolean('VITE_MANDATORY_CUSTOMER_PHONE_REGISTER'),
	PROMOTION_SUGGESTION_CATALOG_PRODUCT_REVISION: parseEnvBoolean('VITE_PROMOTION_SUGGESTION_CATALOG_PRODUCT_REVISION'),
	AB_TEST: '',
	VITE_MANDATORY_ZECA_GATE: parseEnvBoolean('VITE_MANDATORY_ZECA_GATE'),
	VITE_PARTNER_ORDER_IMPORT: parseEnvBoolean('VITE_PARTNER_ORDER_IMPORT'),
	BONI_POINTS_CART: parseEnvBoolean('VITE_BONI_POINTS_CART'),
};

export default features;
